<template>
  <footer class="bg-ink text-white">
    <div class="container mx-auto px-4 max-w-7xl py-12">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
        <!-- Logo and description -->
        <div class="md:col-span-2">
          <img 
            src="/logo-e2m-white.png" 
            alt="E2M Logo" 
            class="h-12 w-auto mb-4"
          />
          <p class="text-gray-300 mb-6 max-w-md">
            Control all your online channels from one place. Centralize listings, inventory, performance data, and product images across all major marketplaces.
          </p>
          <BaseButton variant="primary">
            {{ $t('common.getStarted') }}
          </BaseButton>
        </div>

        <!-- Navigation links -->
        <div>
          <h3 class="font-semibold mb-4">Navigation</h3>
          <nav class="flex flex-col gap-2">
            <router-link
              v-for="item in navItems"
              :key="item.path"
              :to="item.path"
              class="text-gray-300 hover:text-white transition-colors"
            >
              {{ $t(item.label) }}
            </router-link>
          </nav>
        </div>

        <!-- Contact info -->
        <div>
          <h3 class="font-semibold mb-4">Contact</h3>
          <div class="flex flex-col gap-2 text-gray-300">
            <a href="mailto:Info@easytomanage.com" class="hover:text-white transition-colors">
              Info@easytomanage.com
            </a>
            <p>Get in touch for demos and inquiries</p>
          </div>
        </div>
      </div>

      <!-- Bottom bar -->
      <div class="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
        <p class="text-gray-300 text-sm">
          © {{ new Date().getFullYear() }} Easy To Manage (E2M). All rights reserved.
        </p>
        <div class="flex gap-6 mt-4 md:mt-0">
          <router-link to="/privacy" class="text-gray-300 hover:text-white text-sm transition-colors">{{ $t('nav.privacy') }}</router-link>
          <router-link to="/terms" class="text-gray-300 hover:text-white text-sm transition-colors">{{ $t('nav.terms') }}</router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import BaseButton from './BaseButton.vue'
import { navItems } from '@/data/nav'
</script>